module.exports = __webpack_public_path__ + "static/media/rahuk_agarwal.51453d82.jpg";